import { EpimsBaseEntityDto } from './epim-base.dto';

export class RackTrayRefDto extends EpimsBaseEntityDto{
  RackTrayRefNo: string;
  CabinetShelfRefId: string;
  SubscriptionUserId: string; 
  SiteId: string;
  ModifiedById: string;
  CreatedById: string;
  dateUpdated: Date;
  dateCreated: Date;
  Version: Number;
  SubscriberId: string;
  }
